import React from 'react'
import {
  Button,
  Box,
  Typography,
  makeStyles,
  SvgIcon,
  useTheme,
} from '@material-ui/core'
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

const useStyles = makeStyles((theme) => ({
  brokerSelect : {
    width : "100%",
    margin : "16px 0px"
  },
  title : {
    display:"flex",
    alignItems:"center",
  }
}));

interface expandIconProps {
  onClick?:()=>void
}

const ExpandIcon:React.FC<expandIconProps> = ({onClick}) => {
  const theme = useTheme()
  return (
      <SvgIcon style={{transform:"rotate(90deg)",color:theme.palette.primary.main}} onClick={onClick}>
        <ExpandLessIcon/>
      </SvgIcon>
  )
}

interface BrokerCellProps {
  brokerName : string
  brokerID : string
  Icon : any
  handleClickLogin : (brokerName:string,brokerID:string)=>void
}

const BrokerCell:React.FC<BrokerCellProps> = ({
  brokerName,
  brokerID,
  handleClickLogin,
  Icon,
}) => {
  const classes = useStyles();
  return (
    <Button className={classes.brokerSelect} onClick={()=>handleClickLogin(brokerName,brokerID)}>
      {Icon}
      <Box px={1}/>
      <Typography>{brokerName}</Typography>
      <Box flex={1}/>
      <ExpandIcon/>
    </Button>
  )
}

export default BrokerCell